import { render, staticRenderFns } from "./ResumeOfferingHeader.vue?vue&type=template&id=166d2bf5"
import script from "./ResumeOfferingHeader.vue?vue&type=script&lang=ts"
export * from "./ResumeOfferingHeader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports